import {
  File,
  Home,
  Library,
  MessageSquare,
  Palette,
  Settings,
  User,
  Users,
} from 'lucide-react';
import type { GlobalCommandMenuCopy } from './global-command-menu-copy';
import type { GoToItem } from './types';
import { workspaceFilesAvatarListHref } from '@/lib/workspace-avatar-files-route';
import { workspaceFilesMediaHref } from '@/lib/workspace-files-media';

export function getGlobalCommandMenuGoToItems(args: {
  orgSlug?: string;
  term: string;
  text: GlobalCommandMenuCopy;
}): GoToItem[] {
  if (!args.orgSlug) return [];
  const orgSlug = args.orgSlug;
  const all: GoToItem[] = [
    {
      id: 'home',
      label: args.text.home,
      href: `/${orgSlug}`,
      icon: Home,
      shortcutId: 'nav.home',
      keywords: ['home', 'start', 'dashboard'],
      pinned: true,
    },
    {
      id: 'products',
      label: args.text.products,
      href: `/${orgSlug}/products`,
      icon: File,
      shortcutId: 'nav.products',
      keywords: ['products'],
      pinned: true,
    },
    {
      id: 'threads',
      label: args.text.threads,
      href: `/${orgSlug}/threads`,
      icon: MessageSquare,
      shortcutId: 'nav.threads',
      keywords: ['threads', 'chats', 'conversations'],
    },
    {
      id: 'library',
      label: args.text.library,
      href: workspaceFilesMediaHref(orgSlug),
      icon: Library,
      shortcutId: 'nav.library',
      keywords: ['library', 'assets', 'media'],
      pinned: true,
    },
    {
      id: 'avatars',
      label: args.text.avatars,
      href: workspaceFilesAvatarListHref(orgSlug),
      icon: User,
      shortcutId: 'nav.avatars',
      keywords: ['avatars', 'models', 'characters'],
      pinned: true,
    },
    {
      id: 'aesthetics',
      label: args.text.aesthetics,
      href: `/${orgSlug}/aesthetics`,
      icon: Palette,
      keywords: ['aesthetics', 'styles', 'moodboards'],
    },
    {
      id: 'members',
      label: args.text.members,
      href: `/${orgSlug}/settings/members`,
      icon: Users,
      keywords: ['members', 'team', 'people', 'invite'],
    },
    {
      id: 'settings',
      label: args.text.settings,
      href: `/${orgSlug}/settings`,
      icon: Settings,
      shortcutId: 'nav.settings',
      keywords: ['settings', 'preferences', 'configuration'],
    },
  ];
  const lower = args.term.toLowerCase();
  if (!lower) return all.filter((item) => item.pinned);
  return all.filter(
    (item) =>
      item.label.toLowerCase().includes(lower) ||
      item.keywords?.some((keyword) => keyword.includes(lower))
  );
}
